import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { zipInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

// import '@sparta.global.vendors/es6-promise';

/**
 * @method keyMirror
 * @param {Object} obj obj
 * @returns {void}
 */
function keyMirror(obj) {
  let key;
  const ret = {};
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    // eslint-disable-line
    if (obj.hasOwnProperty(key)) {
      // eslint-disable-line
      ret[key] = key;
    }
  }
  return ret;
}
var Cx = keyMirror({
  HOME_LOANS_OVERVIEW_NEW_ZIP_CODE_SUBMIT: null,
  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT: null,
  HOME_LOANS_OVERVIEW_RATES_TABLE_CALCULATOR_SUBMIT: null,
  HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED: null,
  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS: null,
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE: null,
  HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS: null,
  HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE: null
});

// import '@sparta.global.vendors/es6-promise';
const ratesFallbackIds = {
  mortgage: '#ratesTableFallbackMortgageModule',
  refinance: '#ratesTableFallbackRefinance',
  'home-equity': '#ratesTableFallbackHomeEquityModule'
};
const ratesTableIds = {
  mortgage: '#ratesTableMortgageModule',
  refinance: '#ratesTableRefinanceModule',
  'home-equity': '#ratesTableFallbackHomeEquityModule'
};

/**
 * @param {String} action str
 * @param {Object} payload obj
 * @returns {void}
 */
function dispatch(action, payload) {
  // console.groupCollapsed('Dispatching action: ', action);
  // console.log(payload);
  // console.groupEnd();

  // This is a javascript dirty trick. The function passed to
  // setTimeout executes in a new execution context, and exceptions
  // thrown in that context do not bubble out to the calling context
  setTimeout(() => this.Events.pub(action, payload), 0);
}
var Dp = {
  /**
   * @method HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED
   * @param {Object} payload payload
   * @returns {void}
   */
  HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED(payload) {
    // update route
    this.route = payload;

    // dispatch route
    dispatch.bind(this)(Cx.HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED, payload);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_FAILURE
   * @param {Object} error obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_FAILURE(error) {
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_FAILURE, error);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS(payload) {
    const route = {
      ...payload,
      route: this.route,
      id: ratesFallbackIds[this.route],
      module: ratesTableIds[this.route]
    };
    payload = {
      ...route
    }; // eslint-disable-line
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE(payload) {
    const obj = {
      ...payload,
      route: this.route,
      id: ratesFallbackIds[this.route],
      module: ratesTableIds[this.route]
    };
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE, obj);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS(payload) {
    const route = {
      ...payload,
      route: this.route,
      id: ratesFallbackIds[this.route],
      module: ratesTableIds[this.route]
    };
    payload = {
      ...route
    }; // eslint-disable-line
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE
   * @param {Object} payload
   */ // eslint-disable-line
  HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE(payload) {
    const obj = {
      ...payload,
      route: this.route,
      id: ratesFallbackIds[this.route],
      module: ratesTableIds[this.route]
    };
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE, obj);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS(payload) {
    const route = {
      payload,
      route: this.route,
      id: ratesFallbackIds[this.route],
      module: ratesTableIds[this.route]
    };
    payload = {
      ...route
    }; // eslint-disable-line
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE(payload) {
    const obj = {
      ...payload,
      route: this.route,
      id: ratesFallbackIds[this.route],
      module: ratesTableIds[this.route]
    };
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE, obj);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_LEADS_CALL_REQUEST_SUCCESS
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_LEADS_CALL_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_LEADS_CALL_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_OVERVIEW_LEADS_CALL_REQUEST_FAILURE
   * @param {Object} error obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_LEADS_CALL_REQUEST_FAILURE(error) {
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_LEADS_CALL_REQUEST_FAILURE, {
      ...error,
      route: this.route
    });
  },
  /**
   * @HOME_LOANS_OVERVIEW_RATES_TABLE_CALCULATOR_SUBMIT
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_RATES_TABLE_CALCULATOR_SUBMIT(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_RATES_TABLE_CALCULATOR_SUBMIT, payload);
  },
  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_SUCCESS
   * @param {Object} payload obj
   * @returns {void}
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_FAILURE
   */
  // eslint-disable-next-line consistent-return
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE(error) {
    if (error.error.responseJSON && error.error.responseJSON.fieldErrors) {
      dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS, error.error.responseJSON.fieldErrors);
      return true;
    }
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE, {
      ...error,
      route: this.route
    });
  },
  /**
   * @method HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT
   * @param {Object} payload obj
   * @constructor
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT(payload = {}) {
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, payload);
  }
};

// import '@sparta.global.vendors/es6-promise';

/**
 * @return {Boolean} is debugging
 */
function debugging() {
  return spaParams.siteParams.debugging && getParameterByName('debugging') == 'true'; // eslint-disable-line
}

/**
 * @param {String} name name
 * @param {String} url URL
 * @return {String} param
 */
function getParameterByName(name, url) {
  if (!url) url = window.location.href; // eslint-disable-line
  name = name.replace(/[\[\]]/g, "\\$&"); // eslint-disable-line

  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url); // eslint-disable-line

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * @method async
 * @param {String} url URL
 * @param {String} methodType method type
 * @param {Object} payload payload
 * @returns {*|Promise|d.promise|promise} async
 */
function async(url, methodType, payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      async: true,
      cache: true,
      dataType: 'JSON',
      type: methodType,
      data: JSON.stringify(payload),
      contentType: 'application/json; charset=utf-8',
      /**
       * @method error
       * @param {Object} jqXHR xhr
       * @desc If response fails
       * @returns {void}
       */
      error: jqXHR => {
        reject(jqXHR);
      },
      /**
       * @method success
       * @param payload
       * @desc If response is success
       */
      // eslint-disable-next-line
      success: payload => {
        resolve(payload);
      }
    });
  });
}
var Ep = {
  /**
   * @method rates
   * @param {String} url url
   * @param {Object} requestPayload request payload
   * @param {Object} debugData debug data
   * @async POST request
   * @description Mortgage & Refinance rate calls
   * @return {Promise} rates obj
   */
  rates(url, requestPayload, debugData = {}) {
    console.time && console.time('RATES_REQUEST'); // eslint-disable-line

    if (debugging()) {
      const response = {
        debugging: true,
        mock: getParameterByName('mock'),
        rateInputs: requestPayload.rateInputs,
        ...debugData
      };
      console.log('rates debugging success', response);
      return Promise.resolve(response);
    }
    return async(url, 'POST', requestPayload).then(response => {
      console.timeEnd && console.timeEnd('RATES_REQUEST'); // eslint-disable-line
      // resolve rates
      return Promise.resolve(response);
    }).catch(error => {
      console.timeEnd && console.timeEnd('RATES_REQUEST'); // eslint-disable-line
      // reject error
      return Promise.reject({
        ...error,
        ...requestPayload
      }); // eslint-disable-line
    });
  },
  /**
   * @method leadsCall
   * @param {String} url url
   * @param {Object} requestPayload request payload
   * @returns {Function} async
   */
  leadsCall(url, requestPayload) {
    return async(url, 'POST', requestPayload).then(response => Promise.resolve({
      responsePayload: response,
      requestPayload
    })).catch(error => Promise.reject({
      error,
      requestPayload
    })); // eslint-disable-line
  },
  /**
   * @method leadsPhoneNumber
   * @param {String} url
   * @param {String} subCampaignCode
   * @async GET request
   * @desc Will update get leads phone number to display on page
   */
  // ReST API does not currently respece scsCampCode parameter
  leadsPhoneNumber(url, subCampaignCode, scsCampCode, debugData) {
    console.time && console.time('LEADS_PHONE_NUMBER_REQUEST'); // eslint-disable-line
    if (debugging()) {
      console.log('leads phone number debugging success', debugData);
      return Promise.resolve({
        debugging: true,
        ...debugData
      });
    }

    // make leads phone number request
    return async(`${url}${scsCampCode || subCampaignCode}`, 'GET')

    // if leads phone number is successful
    .then(response => {
      console.timeEnd && console.timeEnd('LEADS_PHONE_NUMBER_REQUEST'); // eslint-disable-line
      return Promise.resolve(response);
    })

    // if leads phone number is failure
    .catch(error => {
      console.timeEnd && console.timeEnd('LEADS_PHONE_NUMBER_REQUEST'); // eslint-disable-line
      return Promise.reject(error);
    });
  },
  /**
   * @method getAffiliateInfo
   * @param {String} url - the url for the AJAX call
   * @param {String} urlParams - affiliate code or nmlsid to be passed in the url
   * @param {Object} debugData debug data
   * @desc Retrieves an affiliate's sub-campaign number and phone number
   * @returns {Function} async callback
   */
  getAffiliateInfo(url, urlParams, debugData) {
    if (debugging()) {
      console.log('affiliate info debugging success', debugData);
      return Promise.resolve({
        debugging: true,
        ...debugData
      });
    }
    return async(`${url}${urlParams}`, 'GET').then(response => Promise.resolve(response)).catch(error => Promise.reject({
      error
    })); // eslint-disable-line
  }
};

// import '@sparta.global.vendors/es6-promise';
const mockVariablePayload = {
  pDSProcessID: null,
  pDSErrCode: null,
  pDSErrDesc: null,
  product: {
    productName: 'HELOC',
    productCode: null,
    productSubCode: null,
    productSubClass: null,
    productIdentifier: null,
    productType: null,
    effectiveDate: null,
    resultType: 'MyRequest',
    amorizationTerm: '360.0',
    currentAPR: 5.9,
    currentRate: 5.9,
    lineLoanAmount: 100000.0,
    fixedPayment: 356.0,
    termDraw: 120.0,
    totalAmountFinanced: 100000.0,
    regionState: null,
    promoOffer: {
      introRateType: 'V',
      introRateAmount: 3.99,
      introOfferEndDate: null,
      campaignDescriptor: 'Variable APR for 12 months',
      promoDisclosure: 'You are invited to apply for a Home Equity Line of Credit (HELOC). Your receipt of this material does not mean you have been pre-qualified or pre-approved for any product or service we offer. This is not a commitment to lend; you must submit additional information for review and approval. Sample Rate(s) and APR(s) are for illustrative purposes only and are subject to change without notice. Offer available for new applications submitted between 7/1/19 and 03/31/20 for qualified borrowers with approved line sizes of $100,000 or greater and the 12 month Introductory Period begins on the date the HELOC account is opened.'
    },
    discountRate: '0.85',
    defaultDiscountRate: '0.25',
    udeDiscountRate: '0.60'
  },
  monthlyPaymentAmount: null,
  wsjIndex: 5.5,
  wsjIndexForPopup: null,
  state: 'CA'
};
const mockBauPayload = {
  pDSProcessID: null,
  pDSErrCode: null,
  pDSErrDesc: null,
  product: {
    productName: 'HELOC',
    productCode: null,
    productSubCode: null,
    productSubClass: null,
    productIdentifier: null,
    productType: null,
    effectiveDate: null,
    resultType: 'MyRequest',
    amorizationTerm: '360.0',
    currentAPR: 5.9,
    currentRate: 5.9,
    lineLoanAmount: 100000.0,
    fixedPayment: 356.0,
    termDraw: 120.0,
    totalAmountFinanced: 100000.0,
    regionState: null,
    promoOffer: null,
    discountRate: '0.85',
    defaultDiscountRate: '0.25',
    udeDiscountRate: '0.60'
  },
  monthlyPaymentAmount: null,
  wsjIndex: 5.5,
  wsjIndexForPopup: null,
  state: 'CA'
};

/**
 * @method hasRates
 *
 * @param {Object} payload - the response to a rates AJAX call
 * @returns {Boolean} true if any product provides a valid rate
 */
const hasRates = payload => {
  const some = _.some(payload.mortgageProducts, product => product.rateDetails && product.rateDetails.rate);
  return payload.mortgageProducts && some;
};
var Tf = {
  /**
   * @method mortgageRates
   * @param {Object} calcInput calc input
   * @returns {Object} mortgage rates
   */
  mortgageRates(calcInput) {
    // get mortgage rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.mortgage;
    const payloads = JSON.parse($('#ratePayloadsOverview').attr('data-jcr'));
    const {
      request
    } = payloads[spaParams.pageParams.payloads.mortgageOverview];
    const {
      debugData
    } = payloads[spaParams.pageParams.payloads.mortgageOverview];

    // if calcInput then replace spa params
    if (calcInput) {
      request.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      request.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      request.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      // calculate effective down payment
      request.rateInputs.downPayment = calcInput.rateInputs.purchasePrice - calcInput.rateInputs.amountBorrowed;
    }

    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, request, debugData);

    // make mortgage rates requeset
    return mortgageRatesRequest.then(response => {
      if (hasRates(response)) {
        const {
          rateInputs
        } = response;
        const rates = Object.assign({}, response, {
          rateInputs: Object.assign({}, rateInputs, {
            downpaymentPercentage: 100.00 - rateInputs.loantoValueRatio
          }),
          mortgageProducts: response.mortgageProducts.map(product => {
            const {
              rateDetails
            } = product;
            const pmi = rateDetails && rateDetails.mortgageInsuranceAmount;
            if (pmi) {
              const {
                armAssumptions
              } = rateDetails;
              if (armAssumptions) {
                const paymentTypes = ['armInitialPaymentAmount', 'armFullyIndexedRatePaymentAmount', 'armSubsequentPaymentAdjustAmount_1', 'armSubsequentPaymentAdjustAmount_2', 'armSubsequentPaymentAdjustAmount_3', 'armMaximumInitialRatePayment', 'armMaximumSubsequentResetPayment', 'armMaximumLifetimePayment'];
                paymentTypes.forEach(type => {
                  const paymentAmount = armAssumptions && armAssumptions[type];
                  if (paymentAmount) {
                    armAssumptions[type] += pmi;
                  }
                });
              }
              if (rateDetails.monthlyPayment) {
                rateDetails.monthlyPayment += pmi;
              }
            }
            return product;
          })
        });
        this.Store.addData('mortgage_rates', rates);
        return Promise.resolve(rates);
      }
      // include the request parameters in the error in case they are needed
      return Promise.reject({
        error: 'no rates were returned',
        ...request
      }); // eslint-disable-line
    }).catch(error => {
      this.Store.addData('mortgage_rates', error);
      // include the request parameters in the error in case they are needed
      return Promise.reject({
        error,
        ...request
      }); // eslint-disable-line
    });
  },
  /**
   * @method refinanceRates
   * @param {Object} calcInput calc input
   * @returns {Object} refinance rates
   */
  refinanceRates(calcInput) {
    // get refinance rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.refinance;

    // collect request payload for refinance
    const payloads = JSON.parse($('#ratePayloadsOverview').attr('data-jcr'));
    const {
      request
    } = payloads[spaParams.pageParams.payloads.refinanceOverview];
    const {
      debugData
    } = payloads[spaParams.pageParams.payloads.refinanceOverview];

    // if valid zip
    // if (zipInput) {
    //   if (/\d{5}/.test(zipInput.postalCode)) {
    //     request.rateInputs.postalCode = zipInput.postalCode;
    //   }
    // }
    if (calcInput) {
      request.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      request.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      request.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      request.rateInputs.downPayment = calcInput.rateInputs.purchasePrice - calcInput.rateInputs.amountBorrowed;
    }

    // Let's create the promise for refinance rates request
    const refinanceRatesRequest = Ep.rates(url, request, debugData);

    // make refinance rates request
    return refinanceRatesRequest.then(response => {
      if (hasRates(response)) {
        const rates = Object.assign({}, response, {
          mortgageProducts: response.mortgageProducts.map(product => {
            const {
              rateDetails
            } = product;
            const pmi = rateDetails && rateDetails.mortgageInsuranceAmount;
            if (pmi && rateDetails.monthlyPayment) {
              rateDetails.monthlyPayment += pmi;
            }
            return product;
          })
        });
        this.Store.addData('refinance_rates', rates);
        return Promise.resolve(rates);
      }
      // include the request parameters in the error in case they are needed
      return Promise.reject({
        error: 'no rates were returned',
        ...request
      }); // eslint-disable-line
    }).catch(error => {
      this.Store.addData('refinance_rates', error);
      // include the request parameters in the error in case they are needed
      return Promise.reject({
        error,
        ...request
      }); // eslint-disable-line
    });
  },
  /**
   * @method homeEquityRates
   * @returns {Object} refinance rates
   */
  homeEquityRates() {
    // collect page params for home equity
    let inputs = JSON.parse($('#ratePayloadsOverview').attr('data-jcr'));
    inputs = inputs[spaParams.pageParams.payloads.homeEquityOverview];
    let state = this.Store.getUserSelectedState();
    if (!state) {
      state = spaParams.pageParams.defaultState;
      this.Store.addData('state', state || '');
    }
    inputs.state = state;

    // create homeEquity rates request
    const homeEquityRatesRequest = Ep.rates(spaParams.siteParams.endpoints.homeEquity.url, inputs);

    // run homeEquity rates request
    return homeEquityRatesRequest.then(payload => {
      const {
        mock
      } = payload;
      if (!spaParams.siteParams.isProd && mock === 'promo') {
        return Promise.resolve(mockVariablePayload);
      }
      if (!spaParams.siteParams.isProd && mock === 'bau') {
        return Promise.resolve(mockBauPayload);
      }
      this.Store.addData('home_equity_rates', payload);
      return Promise.resolve(payload);
    }).catch(error => {
      this.Store.addData('home_equity_rates', error);
      return Promise.reject(error);
    });
  },
  /**
   * @method leadsCall
   * @param {Object} payload payload
   * @returns {Function} leads call
   */
  leadsCall(payload) {
    const inputs = {};

    // format email, zip, phone
    inputs.custEmail = payload.emailAddress.trim();
    inputs.mailZipcode = payload.zipCode.slice(0, 5);
    inputs.phoneDay = payload.phoneNumber.replace(/[^\d]/g, '').slice(0, 10);

    // names
    inputs.custFirstName = payload.firstName;
    inputs.custLastName = payload.lastName;

    // format mortgage loan purpose & sub campaign code
    inputs.mtgLoanPurpose = payload.mtgLoanPurpose;
    inputs.subCampaignCode = payload.subCampaignCode;

    // make leads call
    return Ep.leadsCall(spaParams.siteParams.endpoints.leadsCall.url, inputs).then(payload => Promise.resolve(payload)) // eslint-disable-line
    .catch(error => Promise.reject(error));
  },
  /**
   * @method leadsPhoneNumber
   * @param {String} route route
   * @returns {Function} leads phone
   */
  leadsPhoneNumber(route) {
    // params
    const params = Utility.getQueryParamValues(window.location.href);

    // get persisted campaign code
    const persistedSubCampCode = this.Store.getPersisted('subCampaignCode');
    let subCampCode = persistedSubCampCode && persistedSubCampCode.code;

    // if param exist
    let key = Object.keys(params || {}).find(key => /subcampcode/i.test(key) ? key : false); // eslint-disable-line
    if (key) {
      subCampCode = params[key];
    }
    const scsKey = Object.keys(params || {}).find(key => /scscampcode/i.test(key) ? key : false); // eslint-disable-line
    const scsCampCode = scsKey && params[scsKey];

    // sub campaign code
    if (!subCampCode) {
      subCampCode = spaParams.siteParams.subCampaignCodes[route];
    }
    const loanPurposeMap = {
      mortgage: 'PropertyPurchase',
      refinance: 'Refinance',
      'home-equity': 'EquityRelease'
    };
    const loanPurpose = loanPurposeMap[route];

    // there was some discussion of affiliate code coming from a cookie rather than a query param
    key = Object.keys(params || {}).find(key => /affiliatecode/i.test(key) ? key : false); // eslint-disable-line
    let affiliateCode = key && params[key];
    // fetching nmls from cookie
    key = Object.keys(params || {}).find(key => /nmls/i.test(key) ? key : false); // eslint-disable-line
    let nmls = key && params[key];
    let urlParams = null;
    if (nmls) urlParams = `nmls=${nmls}`;else if (affiliateCode) urlParams = `affiliateCode=${affiliateCode}`;else if (!nmls && !affiliateCode) {
      // try to read the affiliate code from a cookie
      const matches1 = document.cookie.match(/boa_hlts_mlo=([^;]+);/);
      const matches2 = document.cookie.match(/boa_hlts_mlo_affiliate=([^;]+);/);
      if (matches1 && matches1.length > 1) {
        nmls = matches1[1]; // eslint-disable-line
        urlParams = `nmls=${nmls}`;
      } else if (matches2 && matches2.length > 1) {
        affiliateCode = matches2[1]; // eslint-disable-line
        urlParams = `affiliateCode=${affiliateCode}`;
      }
    }
    if (urlParams) {
      return Ep.getAffiliateInfo(spaParams.siteParams.endpoints.getAffiliateInfo.url, urlParams, spaParams.siteParams.endpoints.getAffiliateInfo.debugData).then(response => {
        const phone = response.phoneNumber;
        const matches = phone && phone.match(/(\d{3})(\d{3})(\d{4})/);
        if (matches.length > 3) {
          const digitGroups = matches.slice(1, 4);
          const phoneNumber = digitGroups.join('-');
          this.Store.addData(`${route}_phoneNumber`, {
            phoneNumber
          });
          this.Store.persist('subCampCode', {
            code: response.subCampCode
          });
          const {
            debugging,
            firstName: fName,
            lastName: lName
          } = response;
          const Source = 'MLOWebsite';
          const Subsource = 'Prequal';
          const originationCode = '18098';
          return Promise.resolve({
            debugging,
            route,
            scsCampCode,
            subCampCode,
            phoneNumber,
            affiliateCode: affiliateCode,
            nmls: nmls,
            fName,
            lName,
            loanPurpose,
            Source,
            Subsource,
            originationCode,
            raw: response
          });
        }
        return Promise.reject({
          error: 'no valid phone number provided'
        }); // eslint-disable-line
      }).catch(error => Promise.reject({
        error
      })); // eslint-disable-line
    }
    // eslint-disable-next-line no-unused-vars
    const {
      debugData
    } = spaParams.siteParams.endpoints.leadsPhoneNumber;
    // lets make phone number call
    return Ep.leadsPhoneNumber(spaParams.siteParams.endpoints.leadsPhoneNumber.url, subCampCode, scsCampCode, debugData).then(payload => {
      // add to store
      this.Store.addData(`${route}_phoneNumber`, payload);

      // persist data
      this.Store.persist('subCampaignCode', {
        code: subCampCode
      });

      // return promise
      return Promise.resolve({
        route,
        scsCampCode,
        subCampCode,
        ...payload
      });
    }).catch(error => Promise.reject({
      error,
      scsCampCode,
      subCampCode
    })); // eslint-disable-line
  }
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"ratePayloadsOverview\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ratePayloads") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":64}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/services-mortgage-overview-module",
  "version": "3.0.3",
  "id": "servicesMortgageOverviewModule",
  "containerID": "homeLoansServicesMortgageOverviewModule",
  "moduleName": "home-loans-services-mortgage-overview-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "services-mortgage-overview-module",
  "data": {
    "init": "servicesMortgageOverviewModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "controller",
    "type": "string",
    "values": [],
    "default": "",
    "description": "This parameter allows changing the controller."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        zipInput,
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    zipInput,
    json
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

// import RouterBackboneUtility from '@sparta.community.utilities/router-backbone-utility/dist/es6.js';

/**
 * @export
 * @class servicesMortgageOverviewModule
 * @extends {Module}
 */
class servicesMortgageOverviewModule extends Module {
  /**
   * Creates an instance of Controllers.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof Controllers
   */
  constructor(options, context) {
    // Extend Module
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @method mortgage
   * @route
   */
  // eslint-disable-next-line
  mortgage() {
    // update route
    Dp.HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED.bind(this)('mortgage');

    // get information from sthe store
    const mortgage_rates = this.Store.getData('mortgage_rates'); // eslint-disable-line
    const mortgage_phoneNumber = this.Store.getData('mortgage_phoneNumber'); // eslint-disable-line

    const rate = _.last(mortgage_rates) || mortgage_rates; // eslint-disable-line

    if (rate && rate.error) {
      Dp.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(rate);
    } else {
      Dp.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(rate);
    }

    // check if mortgage phone number exist
    if (!mortgage_phoneNumber) {
      // eslint-disable-line
      this.leadsPhoneNumber('mortgage');
      return false;
    }

    // emit mortgage phone number
    Dp.HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS.bind(this)(mortgage_phoneNumber);
  }

  /**
   * @method refinance
   * @route
   */
  // eslint-disable-next-line
  refinance() {
    // update route
    Dp.HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED.bind(this)('refinance');

    // check store for refinance
    const refinance_rates = this.Store.getData('refinance_rates'); // eslint-disable-line
    const refinance_phoneNumber = this.Store.getData('refinance_phoneNumber'); // eslint-disable-line

    const rate = _.last(refinance_rates) || refinance_rates; // eslint-disable-line

    // if refinance exist

    if (rate && rate.error) {
      Dp.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(rate);
    } else {
      Dp.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(rate);
    }

    // if refinance doesn't make phone number call
    if (!refinance_phoneNumber) {
      // eslint-disable-line
      this.leadsPhoneNumber('refinance');
      return false;
    }

    // emit phone number request for refinance
    Dp.HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS.bind(this)(refinance_phoneNumber);
  }

  /**
   * @method home equity
   * @route
   */
  // eslint-disable-next-line
  homeEquity() {
    // update route
    Dp.HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED.bind(this)('home-equity');
    const home_equity_rates = this.Store.getData('home_equity_rates'); // eslint-disable-line
    const home_equity_phoneNumber = this.Store.getData('home-equity_phoneNumber'); // eslint-disable-line

    const rate = _.last(home_equity_rates) || home_equity_rates; // eslint-disable-line

    // home equity exist
    if (!home_equity_rates) {
      // eslint-disable-line
      Dp.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE.bind(this)(rate);
    } else {
      Dp.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS.bind(this)(home_equity_rates);
    }

    // if home equity doesn't have phone number
    if (!home_equity_phoneNumber) {
      // eslint-disable-line
      this.leadsPhoneNumber('home-equity');
      return false;
    }

    // emit phone number request for home equity
    Dp.HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS.bind(this)(home_equity_phoneNumber);
  }

  /**
   * @method rates
   * @returns {void}
   */
  rates() {
    // mortgage rates
    Tf.mortgageRates.bind(this)(false).then(payload => {
      Dp.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });

    // refinance rates
    Tf.refinanceRates.bind(this)(false).then(payload => {
      Dp.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });

    // lets make rates call
    Tf.homeEquityRates.bind(this)(false).then(payload => {
      Dp.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @method chooseCalculatorSubmitController
   * @param {Object} request request
   * @returns {void}
   */
  chooseCalculatorSubmitController(request) {
    const inp = request.data;
    const {
      downPayment
    } = inp.rateInputs;

    // get controller
    const controller = downPayment === 0 ? 'refinanceCalculator' : 'mortgageCalculator';

    // call controller passing in inputs from calculator
    this[controller](inp);
  }

  /**
   * @method mortgage
   * @param {Object} calcInput calc input
   * @route
   * @returns {void}
   */
  mortgageCalculator(calcInput) {
    // lets make rates call
    Tf.mortgageRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @method refinance
   * @param {Object} calcInput calc input
   * @route
   * @returns {void}
   */
  refinanceCalculator(calcInput) {
    // lets make rates call
    Tf.refinanceRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @method leadsCall
   * @param{Object} request request
   * @controller
   * @returns {void}
   */
  leadsCall(request) {
    const payload = request.data;

    // Making leads call
    Tf.leadsCall(payload).then(payload => {
      // eslint-disable-line
      Dp.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @method leadsPhoneNumber
   * @param {Object} route route
   * @returns {void}
   */
  leadsPhoneNumber(route) {
    // make leads phone number call
    Tf.leadsPhoneNumber.bind(this)(route).then(payload => {
      Dp.HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @method updateRoute
   * @returns {void}
   */
  updateRoute() {
    $(`.route-${this.route}`).removeClass('hide');
  }

  /**
   * @method showSpinner
   * @returns {void}
   */
  showSpinner() {
    $('div[data-sparta-container="mortgage"]').find('.small-centered.section-body').not('.route-footer').not('.route-all').addClass('hide');
    $('#spinnerModule').fadeIn({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @method notFound
   * @redirect
   * @returns {void}
   */
  notFound() {
    // this.router.navigate('#/mortgage');
    this.mortgage();
  }

  /**
   * @returns {void}
   */
  checkHashAndTriggerContent() {
    const {
      hash
    } = window.location;

    // Capture #refinance & #/refinance
    if (hash && this.routes[hash.substring(1)]) {
      this.routes[hash.substring(1)]();
    } else if (hash && this.routes[hash.substring(2)]) {
      this.routes[hash.substring(2)]();
    } else {
      this.routes['*notFound']();
    }
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    this.Store.removePersisted('subCampCode');
    this.Store.removePersisted('subCampaignCode');

    // request rates
    this.rates.bind(this)();

    // configure your routes
    this.routes = {
      '': () => {
        this.mortgage.bind(this)();
      },
      mortgage: this.mortgage.bind(this),
      refinance: this.refinance.bind(this),
      'home-equity': this.homeEquity.bind(this),
      '*notFound': this.notFound.bind(this)
    };
    this.checkHashAndTriggerContent();
    window.addEventListener('hashchange', () => {
      this.checkHashAndTriggerContent();
    });

    // when any of the pages rates successful
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS, this.updateRoute.bind(this));
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS, this.updateRoute.bind(this));
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS, this.updateRoute.bind(this));
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE, this.updateRoute.bind(this));
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE, this.updateRoute.bind(this));
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE, this.updateRoute.bind(this));

    // when hash route is updated
    this.Events.sub(Cx.HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED, this.showSpinner.bind(this));

    // When leads call is submitted
    this.Events.sub(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, this.leadsCall.bind(this));

    // When refinance zip code is resubmitted
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_NEW_ZIP_CODE_SUBMIT, this.refinanceCalculator.bind(this));

    // When rates calculator is submitted
    this.Events.sub(Cx.HOME_LOANS_OVERVIEW_RATES_TABLE_CALCULATOR_SUBMIT, this.chooseCalculatorSubmitController.bind(this));
  }
}
registerModuleClass({
  moduleClass: servicesMortgageOverviewModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { servicesMortgageOverviewModule as default, moduleConfig };
